export enum ProductType{
  版型=0,
  面料= 1,
  辅料= 2,
  饰品=3,
  成衣=4 , 
  成衣定制=5,
  视频课程=6
}